import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { environment } from "src/environments/environment";
import { ApiErrorHandlerService } from "./api-error-handler.service";
import { Observable, catchError } from "rxjs";
import { AtoLudConsulta } from '../model/ato-lud-consulta.model';
import { AtoRecurso } from "../model/ato-recurso.model";
import { Recurso } from "../model/recurso.model";
import { FragmentoAtoSegmento } from "../model/fragmento-ato-segmento.model";
import { LudEncontrado } from "../model/lud-encontrado.model";

@Injectable({
    providedIn: 'root'
})
export class LudService {

    private readonly baseUrl = `${environment.apiUrl}/lud`;

    constructor(
        private readonly http: HttpClient,
        private readonly errorHandler: ApiErrorHandlerService
    ) { }

    consultarAtos(atoLudConsulta: AtoLudConsulta): Observable<AtoRecurso[]> {
        const url = `${this.baseUrl}/ato/consultar`;
        return this.http.post<AtoRecurso[]>(url, atoLudConsulta).pipe(catchError(this.errorHandler.handle()));
    }

    consultarFragmentos(idAto: number): Observable<FragmentoAtoSegmento[]> {
        const url = `${this.baseUrl}/ato/${idAto}/consultar-fragmentos`;
        return this.http.get<FragmentoAtoSegmento[]>(url).pipe(catchError(this.errorHandler.handle()));
    }

    consultarLudsInternet(texto: string): Observable<Recurso[]> {
        const url = `${this.baseUrl}/recurso/consultar-externos/${texto}`;
        return this.http.get<Recurso[]>(url).pipe(catchError(this.errorHandler.handle()));
    }

    localizar(texto: string): Observable<LudEncontrado[]> {
        const url = `${this.baseUrl}/localizar`;
        return this.http.post<LudEncontrado[]>(url, texto).pipe(catchError(this.errorHandler.handle()));
    }
}